import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_ADMIN_URL;

export const verifyCoupon = async (couponCode, userId, orderId) => {
  const response = await axios.post(`${BASE_URL}/verify-coupon`, {
    coupon_code: couponCode,
    user_id: userId,
    order_id: orderId || userId,
  });
  return response.data;
};
